module.exports = __webpack_public_path__ + "img/FROM-OLDMUTUAL-desktop.e8bb81ad.svg";